import {
    Input,
    Component,
    Output,
    EventEmitter,
    OnDestroy
} from '@angular/core';
import { IDynamicallyCreatedComponent } from '../core-data-model/DynamicallyCreated.component';
import { TranslationService } from '../translations';

@Component({
    template: `
        <div class="pi-modalBody_simpleText">
            <div class="title-md" [innerHTML]="text"></div>
            @if (subtitleText) {
                <div style="margin-top: 5px;" [innerHTML]="subtitleText"></div>
            }
        </div>
        <div class="pi-modalFooter">
            <div class="btn--lsg_centeredContainer">
                <button
                    data-testing="confirmRequest"
                    type="button"
                    class="button button-md button-primary"
                    (click)="confirmRequest(true)"
                >
                    {{ TR.key(confirmationButtonKeys.yes) }}
                </button>
                <button
                    type="button"
                    class="button button-md  button-tertiary"
                    (click)="confirmRequest(false)"
                >
                    {{ TR.key(confirmationButtonKeys.no) }}
                </button>
            </div>
        </div>
    `,
    standalone: false
})
export class ConfirmationComponent
    implements IDynamicallyCreatedComponent, OnDestroy
{
    @Output()
    readonly confirm = new EventEmitter();

    outputEvents = ['confirm'];
    subscriptions: any[];

    @Input()
    text = '';
    @Input()
    subtitleText = '';
    @Input()
    confirmationButtonKeys: {
        yes: string;
        no: string;
    };

    get propertiesList(): string[] {
        return ['text', 'subtitleText', 'confirmationButtonKeys'];
    }

    constructor(public TR: TranslationService) {}

    confirmRequest(isConfirmed: boolean) {
        this.confirm.emit(isConfirmed);
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => {
                subscription.unsubscribe();
            });
        }
    }
}
